import Backbone from 'backbone';

function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}
export function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}
export function setUpCSRF(){
    Backbone.$.ajaxSetup({
        headers: {'X-CSRFToken': getCookie("csrftoken")}
    });
}



// WEBPACK FOOTER //
// ./frontend/js/utils/csrf.js